import axios from "@/plugins/axios";

let url = "/api/v1/counsels";

export default {
    gets(data) {
        return axios.get(url, data).then((result) => result.data);
    },
    get(data) {
        return axios.get(`${url}/${data._id}`).then((result) => result.data);
    },
    post(data) {
        return axios.post(url, data).then((result) => result.data);
    },
    put(data) {
        return axios.put(`${url}/${data._id}`, data).then((result) => result.data);
    },
    delete(data) {
        return axios.delete(`${url}/${data._id}`).then((result) => result.data);
    },
    responses: {
        post(data) {
            return axios.post(`${url}/responses`, data).then((result) => result.data);
        },
        put(data) {
            return axios.put(`${url}/responses/${data._id}`, data).then((result) => result.data);
        },
        delete(data) {
            return axios.delete(`${url}/responses/${data._id}`).then((result) => result.data);
        },
    },
    comments: {
        post(data) {
            return axios.post(`${url}/comments`, data).then((result) => result.data);
        },
        put(data) {
            return axios.put(`${url}/comments/${data._id}`, data).then((result) => result.data);
        },
        delete(data) {
            return axios.delete(`${url}/comments/${data._id}`).then((result) => result.data);
        },
    },
    files: {
        post({ _response, _request, index }, file) {
            var headers = { "Content-Type": "multipart/form-data" };
            var formData = new FormData();
            if (_response) formData.append("_response", _response);
            if (_request) formData.append("_request", _request);
            if (index !== undefined) formData.append("index", index);
            formData.append("file", file);
            return axios.post(`${url}/files`, formData, { headers }).then((result) => result.data);
        },
        delete(data) {
            return axios.delete(`${url}/files/${data._id}`).then((result) => result.data);
        },
    },
    summary: {
        get(data) {
            return axios.get(`${url}/summary`, data).then((result) => result.data);
        },
    },
};
